import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-update-app-status',
  templateUrl: './update-app-status.component.html',
  styleUrls: ['./update-app-status.component.scss']
})
export class UpdateAppStatusComponent implements OnInit {
  showLoader: boolean = false;
  updating: boolean = false;
  appStatusId: any;
  selectedStartStatus: any;
  selectedEndStatus: any;

  editAppStatus = new FormGroup({
    appStatusNameAr: new FormControl('', [
      Validators.required,
    ]),
    appStatusNameEn: new FormControl('', [
      Validators.required,
    ]),
    startStatus: new FormControl('', [
      Validators.required,
    ]),
    endStatus: new FormControl('', [
      Validators.required,
    ]),
    orderNo: new FormControl('', [
      Validators.required,
    ])
  });

  constructor(private admService: AdmService, private toastrService: ToastrService, public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router, public translate: TranslateService) { }

  ngOnInit(): void {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.appStatusId = params['appStatus'] || "";

        if (this.appStatusId != "") {
          this.getAppStatus();
        } else {

          this.toastr.warning(this.translate.instant('APP_STATUS_ID_NOT_FOUND'));
          this.router.navigate(['/admission/app-statuses']);
        }
      });
  }

  getAppStatus() {
    this.showLoader = true;
    this.admService.geAppStatus(this.appStatusId)
      .subscribe(
        data => {
          this.editAppStatus.controls.appStatusNameAr.setValue(data.appStatusNameAr);
          this.editAppStatus.controls.appStatusNameEn.setValue(data.appStatusNameEn);
          this.editAppStatus.controls.orderNo.setValue(data.orderNo);
          console.log(data.startStatus);
          this.editAppStatus.controls.startStatus.setValue(data.startStatus);
          this.selectedStartStatus = data.startStatus;
          this.editAppStatus.controls.endStatus.setValue(data.endStatus);
          this.selectedEndStatus = data.endStatus;
        },
        error => {
          this.showLoader = false
          this.toastrService.error(this.translate.instant('CAN_NOT_GET_APP_STATUS') + " #" + this.appStatusId);
        },
        () => this.showLoader = false
      );
  }

  editAppStatusSubmit() {
    this.updating = true;
    let orgid = this.globals.orgId;
    let appStatusNameAr = this.editAppStatus.controls.appStatusNameAr.value;
    let appStatusNameEn = this.editAppStatus.controls.appStatusNameEn.value;
    let orderNo = this.editAppStatus.controls.orderNo.value;
    let startStatus = this.editAppStatus.controls.startStatus.value;
    let endStatus = this.editAppStatus.controls.endStatus.value;

    this.admService.updateAppStatus(orgid, this.appStatusId, appStatusNameAr, appStatusNameEn, orderNo, startStatus, endStatus).subscribe(
      data => {
        this.router.navigate(['/admission/app-statuses']);
        this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
      },
      error => {
        this.updating = false
        this.toastr.error(this.translate.instant('CAN_NOT_UPDATE_APP_STATUS'));
      },
      () => this.updating = false
    );
  }

  editAppStatusChange() { }
  changeStartStatus(newValue: any) {
    this.selectedStartStatus = newValue;
  }

  changeEndStatus(newValue: any) {
    this.selectedEndStatus = newValue;
  }

}
